import {
  DEFAULT_TEACHER_PERMISSIONS,
  TEMA_PERMISSIONS,
  TEMA_ROLES,
} from "./temaRouteConstants";

export function getTeacherPermissions(isAuthenticated) {
  if (!isAuthenticated) {
    return [];
  }

  return DEFAULT_TEACHER_PERMISSIONS;
}

export function getTeacherRole(isAuthenticated) {
  return isAuthenticated ? TEMA_ROLES.TEACHER : null;
}

export function hasRoutePermission(route, permissions = []) {
  if (!route?.permissions?.length) {
    return true;
  }

  return route.permissions.every((permission) => permissions.includes(permission));
}

export function canAccessRoute(route, { isAuthenticated, permissions } = {}) {
  if (!route) {
    return false;
  }

  if (route.requiresAuth && !isAuthenticated) {
    return false;
  }

  return hasRoutePermission(route, permissions);
}

export { TEMA_PERMISSIONS, TEMA_ROLES, DEFAULT_TEACHER_PERMISSIONS };
